import { useEffect, useState } from 'react';

export default function useFormattedTime(secondsRemaining) {
    const [formattedTime, setFormattedTime] = useState<string>();

    useEffect(() => {
        let seconds: number | string = secondsRemaining % 60;
        let minutes: number | string = Math.floor(secondsRemaining / 60);
        minutes = minutes.toString().length === 1 ? '0' + minutes : minutes;
        seconds = seconds.toString().length === 1 ? '0' + seconds : seconds;

        setFormattedTime(minutes + ':' + seconds);
    }, [secondsRemaining]);

    return formattedTime;
}
